/**
 * 装備品（カーボンキュー等）に応じてキュー外観を切り替える自前モジュール（GPL非依存）。
 *
 * - 3D キューメッシュのシャフト material color を上書き
 * - ショットUI（HTML キュースタイル）の SVG を CSS 変数で切替
 *
 * vendor 改変は最小限（cuemesh.ts でシャフトに name="cueShaft" を付けるだけ）。
 * 色適用はここで完結し、装備変更で何度呼んでも安全に動作する（material は cue.mesh が
 * 保持しており共有しないので、ここで color を直接書き換える）。
 */

import { Color, Mesh, MeshPhongMaterial } from 'three';
import type { Cue } from './vendor/cue.js';

/** 既定シャフト色（vendor cuemesh.ts の ashWoodMat と一致）。 */
const DEFAULT_SHAFT_COLOR = 0xd2b48c;

/** カーボンキュー時の SVG（public/cue-carbon.svg）。装備品 effects.shaftColor の有無で切替。 */
const CARBON_SVG_URL = "url('/cue-carbon.svg')";
const DEFAULT_SVG_URL = "url('/cue.svg')";

/** 装備品 effects.shaftColor を 3D キュー mesh / HTML キュー画像へ反映する。
 *  colorCss が未指定（装備なし or 通常キュー）なら既定色＋既定 SVG に戻す。 */
export const applyCueShaftAppearance = (cue: Cue, colorCss?: string): void => {
  // 3D キュー: シャフトメッシュの material.color を更新（vendor の name="cueShaft" 経由）。
  const shaft = cue.mesh.getObjectByName('cueShaft');
  if (shaft instanceof Mesh) {
    // material は MeshPhongMaterial 単一（vendor 実装）。配列形式は来ない前提。
    const mat = shaft.material as MeshPhongMaterial | undefined;
    if (mat && mat.color instanceof Color) {
      const next = new Color(
        colorCss ?? `#${DEFAULT_SHAFT_COLOR.toString(16).padStart(6, '0')}`,
      );
      mat.color.copy(next);
      mat.needsUpdate = true;
    }
  }
  // ショットUI: CSS 変数を root に書き込んで .pool-cue-stick の background を切替。
  // 現状は「shaftColor が指定されているならカーボン SVG」のシンプルな判定。
  // 将来別シャフト色が増えたら effects.shaftSvgUrl を新設して直接駆動する。
  try {
    const url = colorCss ? CARBON_SVG_URL : DEFAULT_SVG_URL;
    document.documentElement.style.setProperty('--cue-svg-url', url);
  } catch (err) {
    console.error('cue SVG 変数更新失敗:', err);
  }
};
